import { observer } from 'mobx-react-lite'
import { useServiceStore } from '../../ServiceStore'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { themeConfig }from '@gap/shared/theme'
import IconButtonWithProgress from 'reusable/mui/progress-icon-button/IconButtonWithProgress'
import Stack from '@mui/material/Stack'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'

export default observer(function ServiceActionDelete() {
   const serviceStore = useServiceStore()
   const sxProps = serviceStore.disableDeleteButton ? {} : { color: themeConfig.destroyButtonColor }
   return <>
      {serviceStore.reallyDelete &&
         <Stack direction='row'>
            <ButtonWithProgress sx={{ color: themeConfig.destroyButtonColor }}
               icon={<DeleteOutlinedIcon sx={{ color: themeConfig.destroyButtonColor }} />}
               iconAndLoadingPosition='start'
               loading={serviceStore.serviceDeleteLoader.isLoading}
               onClick={serviceStore.deleteService}>
               Yes, really delete
            </ButtonWithProgress>
         </Stack>
      }

      {!serviceStore.reallyDelete && <IconButtonWithProgress onClick={serviceStore.displayReallyDelete}
         disabled={serviceStore.disableDeleteButton}>
         <DeleteOutlinedIcon sx={sxProps} />
      </IconButtonWithProgress>
      }
   </>
})
